<template>
  <div
    @mouseover="hover = true"
    @mouseleave="hover = false"
    class="relative h-full border border-transparent hover:border-blue-400"
    :style="{
      'margin-left': marginL + 'px',
      'margin-right': marginR + 'px',
      'padding-left': paddingL + 'px',
      'padding-right': paddingR + 'px',
      'padding-top': paddingT + 'px',
      'padding-bottom': paddingB + 'px',
    }"
  >
    <!-- Column Menu -->

    <div
      ref="menu"
      class="tippy-holder flex flex-row justify-center items-center"
    >
      <div
        class="bubble-menu bg-white rounded-lg p-1 mb-1 shadow-lg flex flex-row justify-center"
      >
        <button
          class="menu is-active"
          v-if="horizontalAttribute == 'start'"
          @click="setAlign('center')"
          v-tooltip="'Horizontal Align'"
        >
          <span class="material-icons">
            format_align_left
          </span>
        </button>

        <button
          class="menu is-active"
          v-if="horizontalAttribute == 'center'"
          @click="setAlign('end')"
          v-tooltip="'Horizontal Align'"
        >
          <span class="material-icons">
            format_align_center
          </span>
        </button>

        <button
          class="menu is-active"
          v-if="horizontalAttribute == 'end'"
          @click="setAlign('start')"
          v-tooltip="'Horizontal Align'"
        >
          <span class="material-icons">
            format_align_right
          </span>
        </button>

        <BasePopover :showPopover="showJustifyMenu" :placement="'bottom-end'">
          <template v-slot:button>
            <button
              class="menu"
              @click="showJustifyMenu = true"
              v-tooltip="'Vertical Align'"
            >
              <span class="material-icons">
                format_line_spacing
              </span>
            </button>
          </template>

          <template v-slot:body>
            <div
              id="button-link"
              class="rounded-lg mt-3 z-10 bg-white border border-solid border-gray-300 inline-block text-left pl-3 pb-3 shadow"
              style="right: 0%;"
            >
              <div class="flex flex-row-reverse">
                <div @click="showJustifyMenu = false">
                  <svg-icon
                    icon="heroicons/outline/x"
                    class="w-3 h-3 text-gray-400 hover:text-gray-500 font-bold mt-2 mr-2 cursor-pointer "
                  />
                </div>
              </div>

              <div class="pr-3">
                <select
                  v-model="verticalAttribute"
                  name="goto"
                  class="mt-1 block w-full py-2 px-3 bg-gray-100 focus:bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                >
                  <option
                    :key="index"
                    v-for="(item, index) in verticalOptions"
                    :value="item.value"
                    >{{ item.name }}
                  </option>
                </select>
              </div>
            </div>
          </template>
        </BasePopover>

        <button
          class="menu is-active"
          v-if="flex === 'col'"
          @click="setFlex('row')"
          v-tooltip="'Content Direction'"
        >
          <span class="material-icons">
            south
          </span>
        </button>

        <button
          class="menu is-active"
          v-else
          @click="setFlex('col')"
          v-tooltip="'Content Direction'"
        >
          <span class="material-icons">
            east
          </span>
        </button>

        <BasePopover :showPopover="showMarginPopover" transition="grow">
          <template v-slot:button>
            <button
              class="menu flex flex-col items-center justify-center relative"
              @click="showMarginPopover = true"
              :style="{ padding: '8px' }"
              v-tooltip="'Margins'"
            >
              <span class="material-icons">
                crop_free
              </span>
            </button>
          </template>

          <template v-slot:body>
            <div
              id="button-settings"
              class="bg-white border border-solid border-gray-300 shadow-lg rounded mt-2 z-10 inline-block text-left pl-3 pb-1"
              style="right: 0%;"
            >
              <div class="flex flex-row-reverse">
                <div @click="showMarginPopover = false">
                  <svg-icon
                    icon="heroicons/outline/x"
                    class="w-3 h-3 text-gray-400 hover:text-gray-300 font-bold mt-2 mr-2 cursor-pointer"
                  />
                </div>
              </div>

              <div
                class="pr-3 flex mb-0 list-none flex-wrap pt-0 pb-1 flex-row"
              >
                <table>
                  <tbody>
                    <tr>
                      <td class="pr-6 py-1"></td>
                      <td class="pr-5 py-1 text-xs text-center text-gray-600">
                        Top
                      </td>
                      <td class="pr-5 py-1 text-xs text-center text-gray-600">
                        Right
                      </td>
                      <td class="pr-5 py-1 text-xs text-center text-gray-600">
                        Bottom
                      </td>
                      <td class="py-1 text-xs text-center text-gray-600">
                        Left
                      </td>
                    </tr>
                    <tr>
                      <td class="pr-3 py-1 text-xs">Margin</td>
                      <td class="pr-5 py-1">
                        <input
                          v-model="marginT"
                          class="text-center w-8 h-8 rounded border border-solid border-gray-300"
                        />
                      </td>
                      <td class="pr-5 py-1">
                        <input
                          v-model="marginR"
                          class="text-center w-8 h-8 rounded border border-solid border-gray-300"
                        />
                      </td>
                      <td class="pr-5 py-1">
                        <input
                          v-model="marginB"
                          class="text-center w-8 h-8 rounded border border-solid border-gray-300"
                        />
                      </td>
                      <td class="py-1">
                        <input
                          v-model="marginL"
                          class="text-center w-8 h-8 rounded border border-solid border-gray-300"
                        />
                      </td>
                    </tr>

                    <tr>
                      <td class="pr-6 py-1"></td>
                      <td class="pr-5 py-1 text-xs text-center text-gray-600">
                        Top
                      </td>
                      <td class="pr-5 py-1 text-xs text-center text-gray-600">
                        Right
                      </td>
                      <td class="pr-5 py-1 text-xs text-center text-gray-600">
                        Bottom
                      </td>
                      <td class="py-1 text-xs text-center text-gray-600">
                        Left
                      </td>
                    </tr>
                    <tr>
                      <td class="pr-3 py-1 text-xs">Padding</td>
                      <td class="pr-5 py-1">
                        <input
                          v-model="paddingT"
                          class="text-center w-8 h-8 rounded border border-solid border-gray-300"
                        />
                      </td>
                      <td class="pr-5 py-1">
                        <input
                          v-model="paddingR"
                          class="text-center w-8 h-8 rounded border border-solid border-gray-300"
                        />
                      </td>
                      <td class="pr-5 py-1">
                        <input
                          v-model="paddingB"
                          class="text-center w-8 h-8 rounded border border-solid border-gray-300"
                        />
                      </td>
                      <td class="py-1">
                        <input
                          v-model="paddingL"
                          class="text-center w-8 h-8 rounded border border-solid border-gray-300"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </template>
        </BasePopover>

        <button
          class="menu flex flex-col items-center justify-center"
          style="padding:0px;"
          v-tooltip="'Delete Section'"
        >
          <div @click="deleteColumn">
            <svg-icon
              icon="heroicons/outline/trash"
              class="w-6 h-6 cursor-pointer"
            />
          </div>
        </button>
      </div>
    </div>

    <!--Column Handle -->

    <div
      v-show="hover"
      @mouseover="handle_hover = true"
      @mouseleave="handle_hover = false"
      class="column-handle material-icons text-white bg-blue-400 rounded-full cursor-pointer"
      ref="trigger"
      v-tooltip="{
        trigger: 'manual',
        show: handle_hover && !bubbleMenu.state.isVisible,
        content:
          length > 1
            ? '<b>Drag</b> to move section<br /><b>Click</b> to open menu'
            : '<b>Click</b> to open menu',
      }"
    >
      keyboard_arrow_up
    </div>

    <!-- Column contents -->
    <draggable
      v-model="contents"
      :group="{ name: 'content', pull: true, put: true }"
      @change="insert"
      class="h-full flex"
      :class="[flexClass, alignClass, justifyClass]"
      draggable=".draggable-content"
      @start="onDragStart"
      @end="onDragEnd"
      @add="onAdd"
      @remove="onRemove"
      handle=".handle"
    >
      <div
        v-for="content in contents"
        :key="content.id"
        class="relative draggable-content flex-initial border border-transparent hover:border-gray-300"
        :class="{
          'w-full':
            content.type == 'FIELD' ||
            content.type == 'CODE' ||
            content.type == 'VIDEO',
        }"
      >
        <component
          v-if="contents.length > 0"
          v-bind:is="content.type + 'Content'"
          @close-menu="$emit('close-menu')"
          @delete-content="deleteContent"
          @copy-content="copyContent"
          :content_id="content.id"
          :survey="survey"
          :dragging="$store.state.dragging"
          :step="step"
          :style="{
            'margin-top': content.marginTop + 'px',
            'margin-bottom': content.marginBottom + 'px',
          }"
        >
        </component>
      </div>

      <div>
        <div v-if="contentCount < 1">
          <div
            v-if="$store.state.chooserVisible"
            class="border border-dashed border-gray-400 py-1 px-2 text-gray-300"
          >
            Drag content to add
          </div>

          <div v-else @click="showContentPopover($event)">
            <svg-icon
              icon="heroicons/outline/plus"
              class="mx-auto my-auto h-8 w-8 cursor-pointer p-1 opacity-75 hover:opacity-100 text-gray-500 bg-gray-200 hover:bg-gray-300 rounded-full"
              v-tooltip="'Add content'"
            />
          </div>
        </div>
      </div>
    </draggable>
  </div>
</template>

<script>
import Column from "@/models/content/Column";
import Row from "@/models/content/Row";
import Content from "@/models/content/Content";
import TEXTContent from "@/components/Content/TextContent";
import IMAGEContent from "@/components/Content/ImageContent";
import BUTTONContent from "@/components/Content/ButtonContent";
import FIELDContent from "@/components/Content/FieldContent";
import CODEContent from "@/components/Content/CodeContent";
import VIDEOContent from "@/components/Content/VideoContent";
import Draggable from "vuedraggable";
import tippy from "tippy.js";

export default {
  name: "content-column",
  components: {
    TEXTContent,
    IMAGEContent,
    BUTTONContent,
    FIELDContent,
    CODEContent,
    VIDEOContent,
    Draggable,
  },
  props: ["column_id", "survey", "step", "row", "length"],
  data() {
    return {
      hover: false,
      handle_hover: false,
      loaded: false,
      showMarginPopover: false,
      showJustifyMenu: false,
      bubbleMenu: null,
      horizontalDragActive: false,
      dragging: false
    };
  },
  computed: {
    column() {
      return Column.query()
        .whereId(this.column_id)
        .with("contents", (query) => {
          query.orderBy("order", "asc");
        })
        .first();
    },
    contents: {
      get() {
        return this.column.contents;
      },
      set(list) {
        var reorderedList = Content.reIndexList(list);
        Content.update({
          data: reorderedList,
        });
      },
    },
    flex: {
      get() {
        return this.column.flex;
      },
      set(dir) {
        Column.update({
          where: this.column.id,
          data: { flex: dir },
        });
      },
    },
    contentCount: {
      get() {
        if (this.dragging) 
          return this.contents.length - 1;
        else  
          return this.contents.length
      },
    },
    horizontalAttribute() {
      if (this.flex === "row") return this.justify;
      //e.g. 'justify-start'
      else return this.align;
    },
    verticalAttribute: {
      get() {
        if (this.flex === "row") return this.align;
        //e.g. 'items-start'
        else return this.justify;
      },
      set(value) {
        if (this.flex === "row") this.align = value;
        else this.justify = value;
      },
    },
    verticalOptions() {
      if (this.flex === "row") {
        return [
          { value: "start", name: "Top" },
          { value: "center", name: "Center" },
          { value: "end", name: "Bottom" },
        ];
      } else {
        return [
          { value: "start", name: "Top" },
          { value: "center", name: "Center" },
          { value: "end", name: "Bottom" },
          { value: "between", name: "Between" },
          { value: "around", name: "Around" },
          { value: "evenly", name: "Evenly" },
        ];
      }
    },
    align: {
      get() {
        return this.column.align;
      },
      set(dir) {
        Column.update({
          where: this.column.id,
          data: { align: dir },
        });
      },
    },
    justify: {
      get() {
        return this.column.justify;
      },
      set(value) {
        Column.update({
          where: this.column.id,
          data: { justify: value },
        });
      },
    },
    bgColor: {
      get() {
        return this.column.bgColor;
      },
      set(value) {
        Column.update({
          where: this.column.id,
          data: { bgColor: value },
        });
      },
    },
    contentMarginT: {
      get() {
        return Number.isInteger(this.content.marginTop)
          ? this.content.marginTop
          : null;
      },
      set(value) {
        if (isNaN(value)) value = null;
        Content.update({
          where: this.content.id,
          data: { marginTop: value },
        });
      },
    },
    contentMarginB: {
      get() {
        return Number.isInteger(this.content.marginBottom)
          ? this.content.marginBottom
          : null;
      },
      set(value) {
        if (isNaN(value)) value = null;
        Content.update({
          where: this.content.id,
          data: { marginBottom: value },
        });
      },
    },
    marginT: {
      get() {
        return Number.isInteger(this.row.marginTop) ? this.row.marginTop : null;
      },
      set(value) {
        if (isNaN(value)) value = null;
        Row.update({
          where: this.row.id,
          data: { marginTop: value },
        });
      },
    },
    marginB: {
      get() {
        return Number.isInteger(this.row.marginBottom)
          ? this.row.marginBottom
          : null;
      },
      set(value) {
        if (isNaN(value)) value = null;
        Row.update({
          where: this.row.id,
          data: { marginBottom: value },
        });
      },
    },
    marginL: {
      get() {
        return Number.isInteger(this.column.marginL)
          ? this.column.marginL
          : null;
      },
      set(value) {
        if (isNaN(value)) value = null;
        Column.update({
          where: this.column.id,
          data: { marginL: value },
        });
      },
    },
    marginR: {
      get() {
        return Number.isInteger(this.column.marginR)
          ? this.column.marginR
          : null;
      },
      set(value) {
        if (isNaN(value)) value = null;
        Column.update({
          where: this.column.id,
          data: { marginR: value },
        });
      },
    },
    paddingL: {
      get() {
        return Number.isInteger(this.column.paddingL)
          ? this.column.paddingL
          : null;
      },
      set(value) {
        if (isNaN(value)) value = null;
        Column.update({
          where: this.column.id,
          data: { paddingL: value },
        });
      },
    },
    paddingR: {
      get() {
        return Number.isInteger(this.column.paddingR)
          ? this.column.paddingR
          : null;
      },
      set(value) {
        if (isNaN(value)) value = null;
        Column.update({
          where: this.column.id,
          data: { paddingR: value },
        });
      },
    },
    paddingT: {
      get() {
        return Number.isInteger(this.column.paddingT)
          ? this.column.paddingT
          : null;
      },
      set(value) {
        if (isNaN(value)) value = null;
        Column.update({
          where: this.column.id,
          data: { paddingT: value },
        });
      },
    },
    paddingB: {
      get() {
        return Number.isInteger(this.column.paddingB)
          ? this.column.paddingB
          : null;
      },
      set(value) {
        if (isNaN(value)) value = null;
        Column.update({
          where: this.column.id,
          data: { paddingB: value },
        });
      },
    },
    flexClass() {
      if (typeof this.column.flex === "string") {
        return `flex-${this.column.flex}`;
      } else return "flex-col";
    },
    alignClass() {
      if (typeof this.column.justify === "string") {
        return `items-${this.column.align}`;
      } else return "items-center";
    },
    justifyClass() {
      if (typeof this.column.justify === "string") {
        return `justify-${this.column.justify}`;
      } else return "justify-evenly";
    },
  },
  methods: {
    setAlign(pos) {
      if (this.flex === "row") {
        this.justify = pos;
      } else {
        this.align = pos;
      }
    },
    setFlex(dir) {
      this.flex = dir;

      //reset to default
      if (dir === "row") {
        this.justify = "center";
        this.align = "center";
      }

      if (dir === "col") {
        this.justify = "evenly";
        this.align = "center";
      }
    },
    log: function(evt) {
      window.console.log(evt);
    },
    /*
    async addNewContent(type, order) {
      let column_id = this.column.id;

      Content.insertOrUpdate({
        data: { type: type, parent_id: column_id, parent_type: 'column', order: order },
      });
    },
    */
    showContentPopover(event) {
      this.$store.commit("SET_CHOOSER_STATE", true);
      //console.log("open it");
      event.stopPropagation();
    },
    async moveContentToColumn(content) {
      //move content to the current column
      content.parent_id = this.column.id;
    },
    onDragStart: function(evt) {
      this.dragging = true;
      this.$store.commit("SET_DRAG_STATE", true);
    },
    /** 
     *  onDragEnd fires on the column that the dragged element was started *from*
     *  while onAdd fires on the column that that column was dragged *to*
     */
    onDragEnd: function(evt) {
      this.dragging = false;
      this.$store.commit("SET_DRAG_STATE", false);
    },
    onAdd: function(evt) {
      this.dragging = false;
    },
    onRemove: function(evt) {
      
    },
    async deleteContent(content) {
      var result = await Content.api().delete(
        "/api/content/delete/" + content.id
      );

      if (result.response.status == 200) {
        await Content.delete(content.id);
      } else {
        //Delete failed
        this.$store.dispatch("notification/add", {
          message: "An error occured deleting section",
        });
      }
    },
    insert(evt) {
      window.console.log(evt);

      if (evt.added != null) {
        const added = evt.added.element;
        const index = evt.added.newIndex;

        let column_id = this.column.id;

        //if no uid, create a new content

        if (added.id == null) {
          Content.insert({
            //data: { type: added.type, column_id: column_id, order: index },
            data: {
              type: added.type,
              parent_id: column_id,
              parent_type: "column",
              order: index,
            },
          });
        } else {
          Content.update({
            where: added.id,
            //data: { type: added.type, column_id: column_id, order: index },
            data: {
              type: added.type,
              parent_id: column_id,
              parent_type: "column",
              order: index,
            },
          });
        }
      }
    },
    async copyContent(model) {
      const clone = await Content.clone(model);
      //clone.column_id = this.column.id;
      Content.insert({
        data: clone,
      });
    },
    async deleteColumn() {
      let row_id = this.column.row_id;

      var result = await Column.api().delete(
        "/api/column/delete/" + this.column.id
      );

      if (result.response.status == 200) {
        await Column.delete(this.column.id);

        let columns = Column.getPeerRecords("row_id", row_id);
        if (columns.length < 1) {
          //Row.delete(row_id);
          this.$emit("delete-row", this.row);
        }
      } else {
        //Delete failed
        this.$store.dispatch("notification/add", {
          message: "An error occured deleting section",
        });
      }
    },
  },
  mounted() {

    this.loaded = true;

    let trigger = this.$refs.trigger;
    let menu = this.$refs.menu;

    this.bubbleMenu = tippy(trigger, {
      content: menu,
      interactive: true,
      duration: 100,
      maxWidth: "none",
      hideOnClick: true,
      trigger: "click",
      onClickOutside(instance, event) {
        instance.hide();
        //console.log(instance);
      },
    });
  },
};
</script>

<style>
.column-handle {
  position: absolute;
  transition: all 0.2s ease-out 0s;
  font-size: 16px;
  right: -8px;
  top: -8px;
}

.column-handle:hover {
  font-size: 28px;
  right: -14px;
  top: -14px;
}
.content-handle {
  position: absolute;
  transition: all 0.2s ease-out 0s;
  font-size: 16px;
  width: 28px;
  margin-left: auto;
  margin-right: auto;
  top: -8px;
}
.content-handle:hover {
  font-size: 28px;
  right: -14px;
  top: -14px;
}
</style>
